import { Control, FieldValues } from "react-hook-form";

import { priorCarriers } from "@covertree/consts";

import { FormAutocomplete } from "../FormAutocomplete";
import { filterOptions } from "./utils";

interface Props<TValues extends FieldValues> {
  control: Control<TValues>;
  name?: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
}

export const FormCurrentInsurerAutocomplete = <TValues extends FieldValues>({
  control,
  name = "insurer",
  label = "Insurance Carrier",
  placeholder = "Start typing ...",
  disabled = false,
}: Props<TValues>) => {
  return (
    <FormAutocomplete
      control={control}
      id="insurance-carrier"
      dataTestId="insurance-carrier-field"
      filterOptions={filterOptions}
      options={priorCarriers}
      name={name}
      disablePortal={false}
      inputStyle={{
        padding: "0px !important",
      }}
      inputProps={{
        sx: {
          padding: "0 13px 0 14px !important",
        },
      }}
      label={label}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};

export default FormCurrentInsurerAutocomplete;
